import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugin/vuetify";
import { loadFonts } from "./plugin/webfontloader";
import i18n from "./plugin/i18n";
import axios from "./plugin/axios";
import { createPinia } from "pinia";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueGridLayout from "vue-grid-layout";
import "@/assets/styles/main.scss";
import VueCookies from "vue-cookies";

const clearLocalhostCache = () => {
  if (typeof window === "undefined") {
    return;
  }

  const hostname = window.location.hostname;
  const isLocalhost =
    hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
  if (!isLocalhost) {
    return;
  }

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(registrations.map((registration) => registration.unregister()))
      )
      .catch(() => {});
  }

  if ("caches" in window) {
    window.caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
      .catch(() => {});
  }
};

const options = {
  position: "top-right",
  timeout: 2508,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 1.29,
  showCloseButtonOnHover: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};

clearLocalhostCache();

loadFonts();
const pinia = createPinia();

// app.config.globalProperties.axios = axios;
// app.use(i18n).use(router).use(store).use(vuetify).mount("#app");

const app = createApp(App)
  .use(i18n)
  .use(router)
  .use(VueGridLayout)
  .use(VueCookies, { expires: "30d" })
  .use(vuetify)
  .use(pinia)
  .use(Toast, options)
  .provide("$axios", axios);

app.mount("#app");
